import { IntlFormatters } from '@olxpwa-lib/i18n/client';
import { object, date, string } from 'yup';

export const MAX_NOTE_LENGTH = 180;

export const validationSchema = (
    formatMessage: IntlFormatters['formatMessage']
) =>
    object({
        dateFrom: date().required(),
        note: string()
            .max(
                MAX_NOTE_LENGTH,
                formatMessage({
                    id: 'service.booking.ad.note.input.max.length',
                    defaultMessage: 'You can only enter up to 180 characters'
                })
            )
            .nullable()
    });
